import { Boundaries } from "@planzone/core";
import { events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = [];

function handleRequest(
  state: State,
  event: Boundaries["retrieveVideoConferenceCallLinks"]["request"],
): State {
  const index = state.findIndex((req) => req.event.uuid === event.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { ...state[index], event, request: setRequestStateToPending() },
        ...state.slice(index + 1),
      ]
    : [...state, { event, request: setRequestStateToPending(), links: [] }];
}

function handleSuccess(
  state: State,
  { event, links }: Boundaries["retrieveVideoConferenceCallLinks"]["success"],
): State {
  const index = state.findIndex((req) => req.event.uuid === event.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { event, request: setRequestStateToSuccess(), links },
        ...state.slice(index + 1),
      ]
    : [...state, { links, event, request: setRequestStateToSuccess() }];
}

function handleFailure(
  state: State,
  event: Boundaries["retrieveVideoConferenceCallLinks"]["failure"],
): State {
  const index = state.findIndex((req) => req.event.uuid === event.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { ...state[index], event, request: setRequestStateToFailure() },
        ...state.slice(index + 1),
      ]
    : [...state, { event, request: setRequestStateToFailure(), links: [] }];
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.retrieveVideoConferenceCallLinksRequested]: handleRequest,
    [events.retrieveVideoConferenceCallLinksSucceeded]: handleSuccess,
    [events.retrieveVideoConferenceCallLinksFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
